<template>
  <PopupBackground>
    <div class="create-new-layer-popup popup-shadow">
      <!-- Header -->
      <div class="header">
        <div class="title">
          <h3>{{ getTexts.title }}</h3>
          <p>{{ getTexts.description }}</p>
        </div>
      </div>
      <simplebar class="contents">
        <SlideXRightTransition>
          <div v-if="isLayerTypeListVisible" class="layer-types-list">
            <div class="layer-list-item" @click="showEventCountPopup">
              <div class="layer-type-icon">
                <icon>bubble_chart</icon>
              </div>
              <div class="flex-col mar-left-15 flex-expand">
                <h4 class="title">New Event Count Analysis</h4>
                <p class="description">
                  Count the events happenining at your entity
                </p>
              </div>
              <icon type="box" size="18">keyboard_arrow_right</icon>
            </div>

            <!-- <div class="layer-list-item" @click="showPropertyAggPopup">
              <div class="layer-type-icon">
                <icon>group_work</icon>
              </div>
              <div class="flex-col mar-left-15 flex-expand">
                <h4 class="title">New Entity Property Analysis</h4>
                <p class="description">
                  Analyze properties of your entity
                </p>
              </div>
              <icon type="box" size="18">keyboard_arrow_right</icon>
            </div> -->

            <!-- <div class="layer-list-item" @click="showTimeSpentPopup">
              <div class="layer-type-icon">
                <icon>timelapse</icon>
              </div>
              <div class="flex-col mar-left-15 flex-expand">
                <h4 class="title">New TimeSpent Analysis</h4>
                <p class="description">
                  Analyze time spent accross your entities
                </p>
              </div>
              <icon type="box" size="18">keyboard_arrow_right</icon>
            </div> -->
          </div>
          <!-- <div v-if="isEntityListVisible" class="entity-list">
            <LoadingBar v-if="showLoading" />
            <div v-if="getEntities && !showLoading" class="flex-col">
              <div
                v-for="entity in getEntities"
                :key="entity.id"
                class="entity-item"
                @click="showEntityConfig(entity)"
              >
                <div class="entity-icon">
                  <icon>device_hub</icon>
                </div>
                <div class="flex-col mar-left-10 flex-expand">
                  <h3 class="title">{{ entity.name }}</h3>
                  <p class="description ellipsis">{{ entity.description }}</p>
                </div>
                <icon type="box" size="18">keyboard_arrow_right</icon>
              </div>
            </div>
          </div> -->
          <!-- <div v-if="isEntityConfigVisible" class="entity-config">
            <div class="flex-col">
              <label>Entity Name</label>
              <input
                v-model="entityName"
                type="text"
                placeholder="Entity Cohort Name"
              />
            </div> -->
          <!-- <div class="flex-row mar-top-10">
              <h4>Default Filters</h4>
              <expand />
              <button class="ghost-button">
                <icon>add</icon>
                Add Default Filters
              </button>
            </div>
            <p class="description">
              No default filters selected. Click on "Add default filters" to
              filter your entities
            </p> -->
          <!-- </div> -->
        </SlideXRightTransition>
      </simplebar>
      <div class="footer">
        <Button type="secondary" text="close" @click="$emit('close')"></Button>
        <Button
          v-if="isEntityConfigVisible"
          type="primary"
          text="Add layer"
          icon="check"
          @click="createEntityModel"
        ></Button>
      </div>
    </div>
  </PopupBackground>
</template>

<script>
import PopupBackground from "@/components/modals/PopupBackground";
import Button from "@/components/global/views/Button";
import { SlideXRightTransition } from "vue2-transitions";
import { mapActions, mapGetters } from "vuex";
import {
  EntityModelLayer,
  EntityPropertyLayer,
} from "../../../models/Layers.model";

export default {
  components: {
    PopupBackground,
    Button,
    SlideXRightTransition,
  },
  data() {
    return {
      isLayerTypeListVisible: true,
      isEntityListVisible: false,
      isEntityConfigVisible: false,
      showLoading: false,
      selectedEntity: null,
      entityName: null,
      texts: {
        layerList: {
          title: "Add new layer",
          description: "Choose a layer type to start visualizing",
        },
      },
    };
  },
  computed: {
    ...mapGetters("Entities", ["getEntities"]),
    getTexts() {
      if (this.isLayerTypeListVisible) {
        return this.texts.layerList;
      }
    },
  },
  methods: {
    showEventCountPopup() {
      this.$emit("openEventTotalsPopup");
      this.$emit("close");
    },
    showTimeSpentPopup() {
      this.$emit("openTimeSpentPopup");
      this.$emit("close");
    },
    showPropertyAggPopup() {
      this.$emit("openPropertyAggPopup");
      this.$emit("close");
    },
    // ...mapActions("Entities", ["fetchEntities"]),
    // ...mapActions("LayerManager", [
    //   "addEntityModel",
    //   "addComputedProp",
    //   "addEntityProp",
    //   "setActiveLayer",
    // ]),
    // ...mapActions("Popup", ["toggleComputedPropertyCreationPopup"]),
    // showLayerTypeList() {
    //   this.isLayerTypeListVisible = true;
    //   this.isEntityListVisible = false;
    //   this.isEntityConfigVisible = false;
    // },
    // showEntityTypeList() {
    //   this.isEntityListVisible = true;
    //   this.isLayerTypeListVisible = false;
    //   this.isEntityConfigVisible = false;
    // },
    // showEntityConfig(entity) {
    //   this.selectedEntity = entity;
    //   this.entityName = entity.name;
    //   this.isEntityListVisible = false;
    //   this.isLayerTypeListVisible = false;
    //   this.isEntityConfigVisible = true;
    // },
    // createEntityModel() {
    //   const model = new EntityModelLayer({
    //     name: this.entityName,
    //     entity_id: this.selectedEntity.id,
    //     entity_name: this.selectedEntity.name,
    //     entity_type: this.selectedEntity.entity_type,
    //   });
    //   const entityProperty = new EntityPropertyLayer({
    //     name: `Unique ${this.entityName}${
    //       this.entityName[this.entityName.length - 1] === "s" ? "" : "s"
    //     }`,
    //     entity_model_id: model.id,
    //     property: {
    //       id: this.selectedEntity.entity_id_col,
    //       name: this.selectedEntity.entity_id_col,
    //     },
    //     aggregation: {
    //       id: "count_unique",
    //       name: "count_unique",
    //     },
    //     value: 0,
    //   });
    //   this.addEntityProp(entityProperty);
    //   this.addEntityModel(model);
    //   this.setActiveLayer(entityProperty);
    //   this.$emit("close");
    // },
    // showComputedPropertyPopup() {
    //   this.toggleComputedPropertyCreationPopup();
    //   this.$emit("close");
    // },
  },
  mounted() {
    // if (!this.getEntities || this.getEntities.length === 0) {
    //   this.showLoading = true;
    //   this.fetchEntities()
    //     .then(() => {
    //       this.showLoading = false;
    //     })
    //     .catch(() => {
    //       this.showLoading = false;
    //     });
    // }
  },
};
</script>

<style lang="scss" scoped>
.create-new-layer-popup {
  width: 450px;
  height: 500px;
  max-height: 500px;
  background: var(--color-default-background);
  border-radius: 5px;
  display: flex;
  flex-direction: column;

  .header,
  .footer {
    padding: 10px;
  }

  .header {
    padding: 20px 15px 10px 15px;
    display: flex;
    align-items: center;
    background: var(--color-secondary);
    border-bottom: 1px solid var(--border-color);
    border-radius: 5px 5px 0 0;

    .title {
      display: flex;
      flex-direction: column;

      h3 {
        font-weight: bold;
      }

      p {
        margin: 0;
        opacity: 0.5;
      }
    }
  }

  .contents {
    display: flex;
    flex-direction: row;
    flex: 1;
    overflow: auto;
    height: 100%;
    background: var(--color-secondary);

    label {
      margin: 0 0 5px 0;
    }
    input {
      margin: 0 0 10px 0;
    }

    .representation {
      margin: 0;
      padding: 10px 0;
      color: var(--color-primary);
    }

    .layer-types-list {
      display: flex;
      flex-direction: column;
      z-index: 1;

      .layer-list-item {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 20px 15px;
        border-bottom: 1px solid var(--border-color);

        .layer-type-icon {
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: var(--color-primary-light);
          color: var(--color-primary);
          border-radius: 5px;
        }

        .title {
          margin: 0;
        }

        .description {
          margin: 0;
          opacity: 0.7;
        }

        &:hover {
          cursor: pointer;
          background: var(--border-color);
          .title,
          .description {
            color: var(--color-primary);
          }
        }
      }
    }

    .entity-list {
      display: flex;
      flex-direction: column;
      z-index: 2;

      .entity-item {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 20px 15px;
        border-bottom: 1px solid var(--border-color);

        .entity-icon {
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: var(--color-primary-light);
          color: var(--color-primary);
          border-radius: 5px;
        }

        .title {
          margin: 0;
        }

        .description {
          margin: 0;
          opacity: 0.7;
        }

        &:hover {
          cursor: pointer;
          background: var(--border-color);
          .title,
          .description {
            color: var(--color-primary);
          }
        }
      }
    }

    .entity-config {
      display: flex;
      flex-direction: column;
      padding: 15px;
      z-index: 3;

      .description {
        opacity: 0.6;
      }

      .ghost-button {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin: 0;
        background: transparent;
        border: 0;
        color: var(--color-primary);
        transition: 0.3s all ease-in-out;

        &:hover {
          cursor: pointer;
          opacity: 0.7;
        }

        &:active {
          transform: scale(0.97);
        }
      }
    }
  }

  .footer {
    background-color: var(--color-default-background);
    display: flex;
    align-items: center;
    justify-content: flex-end;
    border-radius: 0 0 5px 5px;
  }
}
</style>
